var render = function render(_c,_vm){return _c('nav',_vm._b({staticClass:"metanavigation",style:(_vm.data.style),attrs:{"id":_vm.data.id}},'nav',_vm.data.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }